import { render, staticRenderFns } from "./MessageTemplatesFormComponent.vue?vue&type=template&id=07645e20&scoped=true"
import script from "./MessageTemplatesFormComponent.vue?vue&type=script&lang=js"
export * from "./MessageTemplatesFormComponent.vue?vue&type=script&lang=js"
import style0 from "./MessageTemplatesFormComponent.vue?vue&type=style&index=0&id=07645e20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07645e20",
  null
  
)

export default component.exports